import React from 'react';
import { Typography, Fab, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux';


import AddIcon from '@mui/icons-material/Add';

import ProjectCard from '../components/cards/ProjectCard';
import DrawerLayout from '../components/containers/drawerLayout/DrawerLayout'
import ContentContainer from '../components/containers/ContentContainer';

const Home = () => {
    const navigate = useNavigate()
    const projects = useSelector(state => state.projects)

    const handleCreateProject = () => {
        navigate('/createProject')
    }

    return (
        <>
            <DrawerLayout headerTitle='Accueil'>
                <ContentContainer>
                    <Typography
                        variant='h1'
                        sx={{
                            marginBottom: 4,
                            fontSize: { xs: 40, md: 48 },
                        }}
                        fontWeight='bold'>
                        Tous mes projets
                    </Typography>

                    {
                        projects.length !== 0 ?
                            <Grid container spacing={2}>
                                {
                                    projects.map(project => {
                                        return (
                                            <Grid item key={project.projectId}>
                                                <ProjectCard project={project} />
                                            </Grid>
                                        )
                                    })
                                }
                            </Grid>
                            :
                            <>
                                <Typography variant='subtitle2' color="GrayText" sx={{ marginBottom: 4 }} fontSize={20} >
                                    Cliquer sur
                                    <Fab
                                        onClick={() => handleCreateProject()}
                                        variant='extended'
                                        color="primary"
                                        aria-label="add"
                                        size='small'
                                        sx={{ marginX: 1, border: 1, borderColor: '#FFF' }}
                                    >
                                        <AddIcon fontSize="small" />
                                        <Typography variant='button' sx={{ marginLeft: 1 }} fontSize={10}>
                                            Nouveau
                                        </Typography>
                                    </Fab>
                                    pour créer un projet.
                                </Typography>
                            </>
                    }

                </ContentContainer>
            </DrawerLayout>

            <Fab
                onClick={() => handleCreateProject()}
                sx={{ position: 'fixed', bottom: 30, right: 30, border: 1, borderColor: '#FFF' }}
                variant='extended'
                color="primary"
                aria-label="add">
                <AddIcon />
                <Typography variant='button' sx={{ marginLeft: 1 }}>
                    Nouveau
                </Typography>
            </Fab>
        </>
    )
}

export default Home;
